export const matches = (a?: string, b?: string) =>
    (a ?? '').toLowerCase().includes((b ?? '').toLowerCase());
